import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";

export default class PageYarraBend extends Component {
	
	constructor(props) {
    	super(props);
    	this.state = {
			index : 0,			
		}
		this.handleGoTo = this.handleGoTo.bind(this);
    }
    
    handleGoTo(_evt) {
	    _evt.preventDefault();  
	    this.slider.slickGoTo(_evt.currentTarget.getAttribute('data-index'), false);
    }
  			
	render() {
		
		let post = this.props.post;
		
		if (post.yb_gallery) {
	    	const settings = {
				dots: 			false,
				arrows: 		false,
				infinite: 		true,
				speed: 			0,
				slidesToScroll: 1,
				centerMode: 	false,
				variableWidth: 	false,
				beforeChange: 	(current, next) => this.setState({ index:next })
			};
			
			return (				
				
				<div id="yarrabend" className="c-yarra-bend">
					<div className="c-yarra-bend__inner">
						{post.yb_heading &&
							<h2 className="c-yarra-bend__heading" dangerouslySetInnerHTML={{__html:post.yb_heading}}></h2>
						}
						<div className="c-yarra-bend__gallery">
							<Slider ref={slider => (this.slider = slider)} {...settings}>
								{post.yb_gallery.map((slide,i) =>
									{
										return (
											<div className={'inner ' + slide.fitting} key={i}>							
												<FadeIn>
													{onload => (
														<img
															alt={''} 
															src={slide.src} 
															srcSet={slide.srcset} 
															onLoad={onload}
														/>
													)}
												</FadeIn>
											</div>
										)
									}
								)}
							</Slider>
						</div>
						<div className="c-yarra-bend__gallery__footer">
							{post.yb_gallery.map((slide,i) =>
								{
									let letter = '1.';
									if (i === 1) {
										letter = '2.';
									} else if (i === 2) {
										letter = '3.';
									} else if (i === 3) {
										letter = '4.';
									} else if (i === 4) {
										letter = '5.';
									} else if (i === 5) {
										letter = '6.';
									} else if (i === 6) {
										letter = '7.';
									} else if (i === 7) {
										letter = '8.';
									} else if (i === 8) {
										letter = '9.';
									} else if (i === 9) {
										letter = '10.';
									} else if (i === 10) {
										letter = '11.';
									}
									
									if (this.state.index === i) {
										return (
											<a href="#" className="c-yarra-bend__gallery__footer__control state-active" key={i} data-index={i} dangerouslySetInnerHTML={{__html:letter}} onClick={this.handleGoTo}></a>
										)
									} else {
										return (
											<a href="#" className="c-yarra-bend__gallery__footer__control" key={i} data-index={i} dangerouslySetInnerHTML={{__html:letter}} onClick={this.handleGoTo}></a>
										)
									}
								}
							)}
						</div>
						<div className="c-yarra-bend__columns">
							<div className="c-yarra-bend__left">
								{post.yb_text &&
									<div className="scope-text" dangerouslySetInnerHTML={{__html:post.yb_text}}></div>
								}
							</div>
							<div className="c-yarra-bend__right">
								{post.yb_button_text && post.yb_button_url &&
									<a href={post.yb_button_url} target="_blank" className="c-yarra-bend__button" dangerouslySetInnerHTML={{__html:post.yb_button_text}}></a>
								}
							</div>
						</div>
					</div>
				</div>
									
			);
			
		} else {
			return null;
		}
	}
}